module.exports = __webpack_public_path__ + "py.svg?3cccc8b3d9d9cf5a11a939a950181023";